import { render, staticRenderFns } from "./userTabs.vue?vue&type=template&id=7140c2f2"
import script from "./userTabs.vue?vue&type=script&lang=js"
export * from "./userTabs.vue?vue&type=script&lang=js"
import style0 from "./userTabs.vue?vue&type=style&index=0&id=7140c2f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports